import { Col } from 'antd';
import { Row } from 'antd';
import { useState } from 'react';
import CustomButton from '../../../../../v2-components/Antd/Button';
import CustomDivider from '../../../../../v2-components/Antd/Divider';
import CustomInput from '../../../../../v2-components/Antd/Input';
import CustomModal from '../../../../../v2-components/Antd/Modal';
import CustomSelect from '../../../../../v2-components/Antd/Select';
import { checkQuantity } from './handle/check-quantity.handle';
import { dataEditAdapter } from './handle/data-edit-adapter.handle';
import { generateOptions } from './handle/generate-options.handle';

export default function EditQuantityModal(props) {
	const [quantity, setQuantity] = useState(1);
	const [defaultValue, setDefaultValue] = useState(1);

	const onChangeTotal = (e) => {
		setQuantity(e);
	};

	const handleCloseModal = () => {
		setDefaultValue(1);
		props?.setOpenEditQuantity(false);
	};

	return (
		<CustomModal onCancel={handleCloseModal} footer={null} open={props?.openEditQuantity}>
			<h2>Ajuste de stock</h2>
			<CustomDivider />
			<h3>Stock</h3>

			<Row>
				<Col span={12}>
					<h3>Cantidad actual</h3>
					<CustomInput value={`${props?.record?.quantity}`} placeholder="Precio Actual" type="text" className="default" disabled={true} />
				</Col>
				<Col span={12}>
					<h3>Cantidad nueva</h3>
					<CustomSelect
						bordered={true}
						onChange={onChangeTotal}
						placeholder="Ingrese la cantidad"
						type="number"
						disabled={checkQuantity(props?.record?.quantity)}
						options={generateOptions(props?.record?.quantity)}
						defaultValue={defaultValue}
					/>
				</Col>
			</Row>
			<CustomDivider />
			<p style={{marginBottom:'15px'}}>Al cambiar la cantidad de productos los cambios de precios aplicados volveran a los valores originales</p>
			<CustomDivider />

			<div className="button-container">
				<CustomButton onClick={handleCloseModal}>Cancelar</CustomButton>
				<CustomButton onClick={() => props?.handleConfirmQuantity(dataEditAdapter(props, quantity))}>Guardar </CustomButton>
			</div>
		</CustomModal>
	);
}
